var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', [_vm.$options.components['advertisement-top-banner-text'] ? [_c('advertisement-top-banner-text')] : _vm._e(), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_vm.$options.components['health-care-category'] ? [_c('health-care-category')] : _vm._e()], 2), _c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('router-view')], 1)], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }